import React from "react";
import PropTypes from "prop-types";

import { Icon, Modal } from "semantic-ui-react";

export function InsightsViewModal({ children, open, onClose }) {
  return (
    <Modal
      open={open}
      size="large"
      style={{ height: "90%" }}
      data-test="insights-modal"
      onClose={onClose}
    >
      <Modal.Content
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
          padding: "1em",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Icon
            name="x"
            size="large"
            data-test="insights-modal-close-button"
            link
            fitted
            onClick={onClose}
          />
        </div>
        {children}
      </Modal.Content>
    </Modal>
  );
}

InsightsViewModal.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

InsightsViewModal.defaultProps = {
  children: null,
  open: true,
};

export default InsightsViewModal;
